import React from "react";
import ModalidadePgDet from "./ModalidadePgDet";
import toLocale from "../../Utils/ToLocaleString";
import roundCustom from "../../Utils/RoundCustom";

export default function ModalidadePg({ pg, setPg, total, liquido, semValorMaximo, disabled, hideOperacoes, clienteId, tipo, isEntrega, onValorMaximoEnter, tabIndex = 10000 }) {

  return <div style={{ width: "100%" }}>
    {(pg || []).map((x, inx) => {
      return <div style={{ display: "flex" }} key={inx}>
        <ModalidadePgDet
          semValorMaximo={semValorMaximo}
          hideOperacoes={hideOperacoes}
          isEntrega={isEntrega}
          tipo={tipo}
          pg={x}
          liquido={liquido}
          setPg={v => {
            const aux = [...pg];

            const totalAtual = roundCustom(pg.reduce((a, b) => a + b.recebido, 0) - aux[inx].recebido);
            if (v.tipo != "troco" && roundCustom(totalAtual + v.recebido) > liquido)
              v.recebido = roundCustom(liquido - totalAtual);

            aux[inx] = v;
            setPg(aux);
          }}
          onOk={() => {
            const aux = [...pg];
            if (!!(pg || []).at(-1)?.modalidadeId && total >= liquido && !semValorMaximo)
              onValorMaximoEnter();

            if ((pg || []).find(x => !x.modalidadeId) || (total >= liquido && !semValorMaximo))
              return;

            if (semValorMaximo)
              aux.push({ modalidadeId: null, recebido: 0 });
            else
              aux.push({ modalidadeId: null, recebido: roundCustom(liquido - total) });

            setPg(aux);
          }}
          clienteId={clienteId}
          noLabel={inx > 0}
          first={inx === 0}
          index={inx}
          tabIndex={tabIndex}
          disabled={disabled}
          onDelete={() => {
            const aux = [...pg];
            aux.splice(inx, 1);
            setPg(aux);
          }}
        />
      </div>;
    })}
    <p style={{ width: "100%", textAlign: "end", marginLeft: -50 }}>{toLocale(total)}</p>
  </div>;
}
